module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_04-4e73c02b5bec38a111fb5b31a831d3ca.jpg";